import DockingViewState from '../store/schema/DockingViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('updateDockingHeight')(function updateDockingHeight(
    dockingViewState: DockingViewState,
    bottomDockingHeight: number
) {
    dockingViewState.bottomDockingHeight = bottomDockingHeight;
});
